import Vue from "vue";
import Vuex, { mapState } from "vuex";
import firebase from "firebase";
import VuexPersistence from "vuex-persist";
import VueResource from "vue-resource";

import fb from "@/utilities/firebase";
import uuid from "@/utilities/uniqueid";

Vue.use(VueResource);
Vue.use(Vuex);

const state = {
  user: null,
  loading: false,
  signUpError: null,
  trip: "",
  error: null,
  pagination: {
    default: "4"
  },
  userDetails: null,
  company: null,
  locations: null,
  packageVersion: process.env.VERSION,
  endpoint: process.env.VUE_APP_SERVERURL,
  realtimeEndpoint: process.env.VUE_APP_REALTIMEURL,
  razorkey: process.env.VUE_APP_RAZORPAY,
  // endpoint : "http://192.168.2.8:3000/api/",
  imagePath: `https://storage.googleapis.com/${process.env.VUE_APP_PHOTOID_BUCKET}/`,
  attachmentPath: `https://storage.googleapis.com/${process.env.VUE_APP_ATTACHMENT_BUCKET}/`,
  kioskMode: false,
  firstTimeSetup: false,
  groups: [],
  group: "",
  notifications: [],
  mode: "AND",
  selectedTags: []
};
const mutations = {
  setPagination(state, payload) {
    Vue.set(state.pagination, payload.name, payload.pagination);
  },
  setSelectedTags(state, payload) {
    state.selectedTags = payload;
  },
  setMode(state, payload) {
    state.mode = payload;
  },
  setCompany(state, payload) {
    state.company = payload;
  },
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setGroups(state, payload) {
    state.groups = payload;
  },
  setGroup(state, payload) {
    state.group = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  lookerror(state, payload) {
    state.signUpError = payload;
  },
  clearError(state) {
    state.error = null;
  },
  setUserDetails(state, payload) {
    state.userDetails = payload;
  },
  setLocations(state, payload) {
    state.locations = payload;
  },
  setKioskMode(state, payload) {
    state.kioskMode = payload;
  },
  setFirstTime(state, payload) {
    state.firstTimeSetup = payload;
  },
  setTrip(state, payload) {
    state.trip = payload;
  },
  setRecords(state, payload) {
    state.records = payload;
  }
};

const actions = {
  setupFirebase({ commit, dispatch, state }, payload) {
    try {
      fb.init(state, dispatch);
    } catch (e) {
      console.log(e);
    }
  },

  updateToken({ commit, dispatch, state }, payload) {
    //firebaseDB.ref("user_token_link/"+ctx.$store.state.userDetails.id).update({token : fcmToken })

    Vue.http.post(`${state.endpoint}Accounts/updateGcmToken`, { token: payload });
  },

  realtimeDBSetup({ commit, dispatch, state }, payload) {
    try {
      console.log("Listers Ready", state.userDetails.id);
      fb.listners(state, dispatch);
    } catch (e) {
      console.log(e);
    }
  },

  setPagination({ commit, dispatch, state }, payload) {
    commit("setPagination", payload);
  },

  getCompany({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload) {
        console.log("Payload before setting the company Logo", payload);
        commit("setCompany", payload);
        resolve();
      } else {
        Vue.http
          .get(
            `${state.endpoint}companies/${state.userDetails.companyId}?filter[include][relation]=plan&filter[include][scope][include]=module`
          )
          .then(
            response => {
              // success callback
              commit("setCompany", response.body);
              resolve();
            },
            error => {
              reject(error);
            }
          );
      }
    });
  },
  setTrip({ commit, dispatch, state }, payload) {
    commit("setTrip", payload);
  },

  checkKioskMode({ commit, dispatch, state }, payload) {
    commit("setKioskMode", payload);
  },
  checkFirstTimeSetup({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload) {
        commit("setFirstTime", payload.firstTimeSetup);
        resolve();
      } else {
        Vue.http.get(`${state.endpoint}companies/${state.userDetails.companyId}`).then(
          response => {
            // success callback
            commit("setFirstTime", response.body.firstTimeSetup);

            resolve();
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },

  signUserUp({ commit, dispatch }, payload) {
    // commit('setLoading', true)
    // commit('clearError')
    Vue.http.post(`${state.endpoint}Accounts/signupWithCompany`, payload).then(
      response => {
        // success callback
        // this.loaderDialog = false
        dispatch("signUserIn", { email: payload.email, password: payload.password });
      },
      error => {
        commit("lookerror", error);
        // commit('setLoading', false)
      }
    );
  },
  signUserIn({ commit, dispatch }, payload) {
    commit("setLoading", true);
    commit("clearError");

    Vue.http.post(`${state.endpoint}Accounts/login`, payload).then(
      response => {
        // success callback
        // this.loaderDialog = false

        Vue.http.headers.common.authorization = response.body.id;
        commit("setLoading", false);
        commit("setUser", response.body);
        commit("setCompany", response.body.userData.company);
        dispatch("getLocations", { companyId: response.body.userData.company.id });
        dispatch("getGroups");

        if (
          response.body.userData.securitySettings.matchDevice == true &&
          (response.body.userData.deviceFingerprint == "" ||
            !response.body.userData.deviceFingerprint)
        ) {
          console.log("No fingerprint set");
          dispatch("setDeviceFingerprint", response.body.userData);
        } else {
          commit("setUserDetails", response.body.userData);
        }

        // Updating the company first time state as well
        dispatch("checkFirstTimeSetup", response.body.userData.company);
        dispatch("setupFirebase");
        dispatch("realtimeDBSetup");
        dispatch("getNotifications");
      },
      error => {
        commit("setLoading", false);
        commit("setError", error);
      }
    );
  },
  postFormData({ commit }, payload) {
    // console.log(payload)
    return new Promise((resolve, reject) => {
      Vue.http.post(`${state.endpoint}formResponses`, payload).then(
        response => {
          // success callback

          resolve(response.body);
        },
        error => error
        // error callback
      );
    });
  },
  getUserData({ commit, dispatch }, payload) {
    Vue.http
      .get(
        `${state.endpoint}Accounts/${payload.userId}?filter[include]=roles&filter[include]=permission&filter[include]=group&filter[include]=company`
      )
      .then(
        async response => {
          commit("setUserDetails", response.body);
          dispatch("getLocations", { companyId: response.body.companyId });
          dispatch("getGroups");

          dispatch("getCompany");
          // Updating the company first time state as well
          dispatch("checkFirstTimeSetup", response.body.company);
          dispatch("getNotifications");
        },
        error => {
          commit("setError", error);
          // error callback
        }
      );
  },

  async setDeviceFingerprint({ commit, dispatch }, payload) {
    payload.deviceFingerprint = await uuid.get();

    Vue.http
      .patch(`${state.endpoint}Accounts/${payload.id}`, {
        deviceFingerprint: payload.deviceFingerprint
      })
      .then(response => {
        commit("setUserDetails", response.body);
      })
      .catch(e => {
        commit("setError", e);
      });
  },

  getNotifications({ commit, dispatch, state }, payload) {
    Vue.http.post(`${state.endpoint}notifications/show`, { order: `desc` }).then(
      response => {
        commit("setNotifications", response.body);
      },
      error => {
        commit("setError", error);
        // error callback
      }
    );
  },
  getLocations({ commit }, payload) {
    Vue.http.get(`${state.endpoint}Locations/get`).then(
      response => {
        commit("setLocations", response.body);
      },
      error => {
        commit("setError", error);
        // error callback
      }
    );
  },
  getGroups({ commit }, payload) {
    Vue.http.get(`${state.endpoint}groups/get`).then(
      response => {
        commit("setGroups", response.body);
        commit("setGroup", "all");
      },
      error => {
        commit("setError", error);
        // error callback
      }
    );
  },
  logout({ commit }) {
    Vue.http.headers.common.authorization = "";
    firebase.auth().signOut();
    fb.logout();
    commit("setUser", null);
  },
  clearError({ commit }) {
    commit("clearError");
  }
};

const getters = {
  mode: state => state.mode,
  selectedTags: state => state.selectedTags,
  getSelectedTagsAndLocations: state => ({
    tags: _.map(
      _.filter(state.selectedTags, t => t.type == "tag"),
      "id"
    ),
    locations: _.map(
      _.filter(state.selectedTags, t => t.type == "location"),
      "id"
    ),
    mode: state.mode,
    group: state.group
  }),
  company: state => state.company,
  trip: state => state.trip,
  appVersion: state => state.packageVersion,
  notifications: state => state.notifications,
  razorkey: state => state.razorkey,
  notificationsCount(state, getters) {
    var nseen = 0;
    getters.notifications.forEach(n => {
      if (!n.seen) nseen++;
    });
    console.log("Notification counter", nseen);
    //if (nseen == 0) nseen = "";
    return nseen;
  },
  kioskMode(state) {
    return state.kioskMode;
  },
  firstTimeSetup(state) {
    return state.firstTimeSetup;
  },
  user(state) {
    return state.user;
  },
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  signUpError(state) {
    return state.signUpError;
  },
  userDetails(state) {
    return state.userDetails;
  },
  locationDetails(state) {
    return state.locations;
  },
  groups(state) {
    return state.groups;
  },
  group(state) {
    return state.group;
  },
  profilePicture(state) {
    return state.userDetails.profilePicture;
  },
  pagination(state) {
    return state.pagination;
  }
};

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state,
  plugins: [vuexLocal.plugin],
  mutations,
  actions,
  getters
});
